import ButtonIcon from '@components/buttonIcon';
import FeaturesCarousel from '@components/premium/featuresCarousel';
import {PopupPremiumProps} from '@components/popups/premium';
import TransitionSlider from '@components/transition';
import {attachClickEvent} from '@helpers/dom/clickEvent';

type FeatureSlideTabOptions = PopupPremiumProps & {
  header: HTMLElement
};

export default class FeatureSlideTab {
  private backBtn: HTMLButtonElement;
  public tab: HTMLElement;
  public transition: ReturnType<typeof TransitionSlider>;
  public featureCarousel: FeaturesCarousel;

  constructor(options: FeatureSlideTabOptions) {
    this.backBtn = ButtonIcon('left popup-close back-button', {noRipple: true});
    this.initFeaturesTab(options);
  }

  public cleanup() {
    this.featureCarousel?.cleanup();
  }

  private initFeaturesTab(options: FeatureSlideTabOptions) {
    const tab = document.createElement('div');
    tab.classList.add('premium-feature-tab');
    options.header.querySelector('.popup-close').replaceWith(this.backBtn);
    tab.append(options.header);
    this.featureCarousel = new FeaturesCarousel({
      ...options,
      header: options.header
    });
    tab.append(this.featureCarousel.container, this.featureCarousel.controlsContainer);
    this.tab = tab;

    attachClickEvent(this.backBtn, () => {
      this.featureCarousel.slideIndex = undefined;
      this.transition(0);
    }, {listenerSetter: options.listenerSetter});
  }

  public setCarouselSlide(feature: PremiumPromoFeatureType) {
    return this.featureCarousel.selectSlide(feature);
  }
}
